// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1QbKBf8bjewX-9-aVyaDF4","button":"_3yrCPzNmFifwmIhfjPAuLc","selectMeButton":"ifhEfRIEGqshg57LgqQf-"};